import React from 'react';
import Link from '@carvana/ds-link';
import { Summary } from '|/app/services';
import styles from './exchange-banner.module.css';

interface ExchangeBannerProps {
  orderSummary: Summary | null;
  onSeeDetails: () => void;
}

const ExchangeBanner: React.FC<ExchangeBannerProps> = ({ orderSummary, onSeeDetails }) => {

  if (!orderSummary?.swap?.hasActiveSwap) {
    return null;
  }

  const handleSeeDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onSeeDetails();
  };

  return (
    <div className={styles.exchangeBannerWrapper}>
      <div className={styles.bannerContent}>
        <span className={styles.bannerTitle}>Vehicle exchange</span>
        <Link
          href=""
          size="sm"
          onClick={handleSeeDetails}
          className={styles.seeDetailsLink}
          data-analytics-id="pp_swap_see_details"
        >
          See details
        </Link>
      </div>
    </div>
  );
};

export default ExchangeBanner;
